import { defineFcm } from '../shared/factory';

export const FCM_PROMOTED_AUTO_AA_ML_EMAIL_PROMOTION_COUNT = defineFcm('promoted_auto_aa_ml_email_promotion_count')
	.asNumber()
	.withDefault(3)
	.toConfig({
		owner: 'squad-site-platform-comms',
		scope: 'comms-stack',
		supportedGroups: { global: true },
		context: 'comms stack',
		description: 'Number of times the promoted auto AA/ML digest email is sent to a user during onboarding.',
		import: false,
	});
